import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=08095c58&scoped=true&"
import script from "./BasicPage.vue?vue&type=script&lang=js&"
export * from "./BasicPage.vue?vue&type=script&lang=js&"
import style0 from "./BasicPage.vue?vue&type=style&index=0&id=08095c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../applauncher/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08095c58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../applauncher/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
